import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class CatgeoryApi {
  getAllCategory(config) {
    return axios.get(`${baseUrl}/admin/category/catgeoryDetails`, config)
  }

  createCategory(data, config) {
    return axios.post(`${baseUrl}/admin/category/create`, data, config)
  }

  updateCategory(data, config) {
    return axios.put(`${baseUrl}/admin/category/update`, data, config)
  }

  getCategoryById(id, config) {
    return axios.get(
      `${baseUrl}/admin/category/catgeoryDetailsByCode/${id}`,
      config,
    )
  }
  uploadCategoryByExcel(data, config) {
    return axios.post(
      `${baseUrl}/admin/category/uploadCategoryByExcel`,
      data,
      config,
    )
  }
}

export default new CatgeoryApi()
